<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" id="standard-modalLabel">
        {{ (isNew ? 'channel.voipRamalForm.titleAdd' : 'channel.voipRamalForm.titleEdit') | translate }}
      </h4>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        [attr.aria-label]="'channel.voipRamalForm.closeAriaLabel' | translate"
        (click)="close()"
      ></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="formGroup">
        <div class="mb-3">
          <label class="form-label">
            {{ 'channel.voipRamais.attendantHeader' | translate }}
            <span class="text-danger">*</span>
          </label>
          <select formControlName="user" class="form-select">
            <option [ngValue]="null" disabled>{{ 'channel.voipRamalForm.selectAttendant' | translate }}</option>
            @for (user of users; track user._id) {
              <option [ngValue]="user._id">{{ user.name }}</option>
            }
          </select>
          <field-error-component
            [field]="'user'"
            [label]="'channel.voipRamais.attendantHeader' | translate"
            [formGroup]="formGroup"
          />
        </div>

        <div class="mb-3">
          <label class="form-label">
            {{ 'channel.voipRamalForm.sipUserLabel' | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            formControlName="sipUsername"
            class="form-control"
            inputmode="numeric"
            [maxlength]="ramalMaxLength"
            placeholder="Ex.: 1001"
          />
          <span class="help-block">
            <small class="text-muted">
              {{ 'channel.voipRamalForm.sipUserHelp' | translate:{ count: ramalMaxLength } }}
            </small>
          </span>
          <field-error-component
            [field]="'sipUsername'"
            [label]="'channel.voipRamalForm.sipUserShortLabel' | translate"
            [formGroup]="formGroup"
          />
        </div>

        <div class="mb-1">
          <div class="custom-switch mt-2">
            <input
              type="checkbox"
              id="ramalActivated"
              formControlName="activated"
              data-switch="success"
            />
            <label for="ramalActivated">
              <span class="text-muted">
                {{
                  (formGroup.get("activated")?.value
                    ? 'channel.voipRamalForm.ramalActive'
                    : 'channel.voipRamalForm.ramalInactive'
                  ) | translate
                }}
              </span>
            </label>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="close()">
        {{ 'channel.channelForm.cancel' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="save()"
        [disabled]="loading || !formGroup.valid"
      >
        @if (loading) {
          <span class="spinner-border spinner-border-sm me-1"></span>
        }
        {{ (isNew ? 'channel.channelForm.headingAdd' : 'channel.channelForm.update') | translate }}
      </button>
    </div>
  </div>
</div>
